// v. 29MAR21 : result.from_json() otherwise no methods in returned result object
import axios from 'axios';
import { Result } from './Result';
export async function axiosPost(url, data) {
    const payload = {
        data: data,
        headers: { 'content-type': 'application/json' },
        method: 'post',
        url: url,
        withCredentials: true
    };
    const response = await axios(payload);
    let result = new Result();
    if (response.status == 200)
        result.from_json(response.data);
    return result;
}
export function upsert(array, obj, key) {
    if (array === undefined)
        array = [];
    if (!key)
        key = 'id';
    const idx = array.findIndex(item => item[key] === obj[key]);
    if (idx > -1)
        array[idx] = obj;
    else
        array.push(obj);
    return array;
}
